class TreatmentsPopup extends Popup
{
  init ()
  {
    super.init();

    this.form = this.querySelector('treatments-form');

    this.querySelectorAll('.treatments-form-close').forEach(btn => {
      btn.addEventListener('click', this.close.bind(this));
    });

    window.addEventListener('resize', () => {
      this.refresh();
    });

    this.refresh();
  }

  open ()
  {
    this.classList.add('show');
    this.form.goToStep(1);
    this.form.initMaps();
    this.refresh();

    document.body.classList.add('showing-popup');
  }

  refresh ()
  {
    document.documentElement.style.setProperty('--treatments-steps-height', this.form.querySelector('.treatments-form-steps').offsetHeight + 'px');
    document.documentElement.style.setProperty('--treatments-right-height', this.form.querySelector('.treatments-form-right').offsetHeight + 'px');
  }
}

if (!customElements.get('custom-treatments-popup')) {
  customElements.define('custom-treatments-popup', TreatmentsPopup);
}